import { createFileRoute } from "@tanstack/react-router";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-permissions";
import SubscriptionConfigurations from "@/components/subscriptions/subcription-configurations";

export const Route = createFileRoute(
  "/_authenticated/settings/_layout/subscription",
)({
  component: ShippingRoutesConfigurationsPage,
});

function ShippingRoutesConfigurationsPage() {
  return (
    <RouteGuardPermissions
      permissions={[
        { module: "company_subscriptions", actions: ["read", "update"] },
      ]}
    >
      <SubscriptionConfigurations />
    </RouteGuardPermissions>
  );
}
